import Vue, {} from 'vue';
import router from '../router';
import store from '../store/store';
import CreateInteractionButton from '../components/enrich/CreateInteractionButton.vue';
import VideoUploadPanel from '../components/upload/VideoUploadPanel.vue';
import UploadVideoList from '../components/upload/UploadVideoList.vue';
import BillingModals from '../components/billing/BillingModals.vue';
import Playlist from '../components/playlist/Playlist.vue';
const apps = [
    {
        el: '#app .newInteractionSection',
        components: {
            CreateInteractionButton,
        },
    },
    {
        el: '#app #select-direct-upload',
        components: {
            VideoUploadPanel,
            UploadVideoList,
        },
    },
    {
        el: '#app #vue',
        components: {
            BillingModals,
        },
    },
    {
        el: '#app #playlist',
        components: {
            Playlist,
        },
    },
];
export function bootVueApps() {
    apps.forEach((config) => {
        if (typeof config.el === 'string' && document.querySelector(config.el) === null) {
            if (process.env.NODE_ENV === 'development') {
                const style = 'background-color: rgba(66, 184, 131, 0.5); color: #35495e;';
                const componentNames = Object.keys(config.components).join(', ');
                console.debug(`%c[DEBUG] Vue: Element "${config.el}" not found, skipping Vue mount for ${componentNames}`, style);
            }
            return;
        }
        new Vue({
            el: config.el,
            comments: true,
            components: config.components,
            router,
            // @ts-expect-error No overload matches this call
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            store,
        });
    });
}
